import { useState } from 'react';
import styled from 'styled-components';
import { transNum } from '../../../func/func';
import { useNavigate } from 'react-router-dom';
import { isLogin } from '../../../utils/auth';
import Tags from '../../../func/Tags';
const SampleCard = ({ title, list }: any) => {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const showAlert = (message: string, navigation: any) => {
    const confirmed = window.confirm(message);
    if (confirmed) {
      navigate('/login');
    }
  };

  const RenderItem = (list: any) => {
    return list.map((item: any, index: any) => (
      <ItemWrapper
        onClick={() => {
          if (title === 'pAuction') {
            navigate(`/example/pauction/detail/${item.iidx}`);
          } else if (title === 'NPL') {
            navigate(`/example/auction/detail/${item.iidx}?type=b`);
          } else {
            navigate(`/example/auction/detail/${item.iidx}`);
          }
        }}
      >
        <ImgBox>
          <ImgTitle>
            {title === 'auction'
              ? '경매'
              : title === 'pAuction'
                ? '공매'
                : 'NPL'}
          </ImgTitle>
          <img src={item.img} alt="" />
        </ImgBox>
        <InfoWrapper>
          <ItemInfoBox>
            <ItemInfo>
              <div>
                <span>{item.caseno}</span>
              </div>
              <div>{item.address}</div>
            </ItemInfo>
          </ItemInfoBox>
          <ItemPriceBox>
            <ItemPrice>
              <div>매각기일</div>
              <div>
                <span>{item.sale_date}</span>
              </div>
            </ItemPrice>
            <ItemPrice>
              <div>감정가</div>
              <div>
                <span>{transNum(Number(item.a_prc))}원</span>
              </div>
            </ItemPrice>
            <ItemPrice>
              <div>최저가</div>
              <div>
                <span>{transNum(Number(item.m_prc))}원</span>
              </div>
            </ItemPrice>
          </ItemPriceBox>
          <HashTagWrapper>
            <Tags
              data={{ ...item, bid: item.rn, viewgray2: item.viewgray }}
            ></Tags>
          </HashTagWrapper>
        </InfoWrapper>
      </ItemWrapper>
    ));
  };

  return (
    <Container>
      <Inner>{RenderItem(list)}</Inner>
    </Container>
  );
};

export default SampleCard;

const ImgTitle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
  background-color: rgba(55, 56, 60, 0.61);
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 6px 10px;
`;
const Inner = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 282px;
  background-color: #ffffff;
  margin-bottom: 24px;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
`;

const HashTag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;
`;

const HashTagWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  break-word: break-word;

  color: rgba(23, 30, 38, 0.78);
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 17.4px;
  word-wrap: break-word;

  span {
    color: rgba(250, 64, 50, 0.98);
  }
`;

const ImgBox = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    border-radius: 8px;
    width: 282px;
    height: 180px;
  }
`;

const ItemPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  line-height: 18.85px;
  word-wrap: break-word;

  span {
    color: #222222;
    font-weight: 500;
  }
`;

const ItemPriceBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const InfoTitle = styled.div`
  color: #008aff;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;

  span {
    color: #616161;
    font-size: 14px;
    font-weight: 500;
    line-height: 20.3px;
  }
`;

const ItemInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  // padding: 16px;
`;

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  color: #222222;
  font-size: 24px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 34.8px;
  word-wrap: break-word;
`;

const Container = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
`;
